import { Model } from 'src/app/interfaces/api/model';
import { GPS } from 'src/app/interfaces/shared/gps';
// import { Font } from 'three/examples/jsm/loaders/FontLoader.js';
import { Track } from 'src/app/interfaces/api/track';
import { Config } from '../../../interfaces/shared/config';
import * as Tools from '../../shared/threeDTools';
import ViewerMaterials from '../viewer-materials';

export interface ExtendedMesh extends THREE.Mesh {
    init?: THREE.Vector3;
    iconName?: string;
    trackerId?: string;
    metricId?: string;
    fragmentId?: string;
    options?: any;
    offsetAxis?: string;
    lookAtType?: 'ROTATE_2D' | 'ROTATE_3D' | 'ROTATE_2D_CONSTRAINT' | 'ROTATE_3D_CONSTRAINT';
}


export class ForgeObject {
    viewer: Autodesk.Viewing.GuiViewer3D;
    model!: Model;
    options: any;
    icons: any[] = [];
    font!: any;
    materials = ViewerMaterials;

    show: boolean = true;
    showTrace: boolean = false;

    texture!: THREE.Texture;
    mesh!: ExtendedMesh;
    children: ExtendedMesh[] = [];
    tracePath: any = null;
    traceColor: string = 'dark';

    constructor(viewer: any, model: Model, options: any) {
        this.viewer = viewer;
        this.model = model;
        this.options = options;
        let material;
        let color = options
        // let material = options.materialName && this.materials[options.materialName as ViewerMaterialKey] ?
        //     this.materials[options.materialName as ViewerMaterialKey].clone() : this.materials["default"].clone();

        material = new THREE.MeshPhongMaterial({
            name: options.materialName ?? "ForgeObject",
            map: options.texture,
            color: options.color || Config.colors.default
        })

        let geometry;
        if (options.geometry) {

        } else {
            geometry = new THREE.BoxGeometry(1, 1, 1)
        }

        this.buildMesh(geometry, material);
        let scale = this.model.origin.scale;
        this.mesh.scale.set(scale, scale, scale);
        let position = options.position ? new THREE.Vector3(options.position.x, options.position.y, options.position.z) : new THREE.Vector3(0, 0, 0);
        this.mesh.name = this.options.name ?? "ForgeObject";
        this.mesh.scale.set(scale, scale, scale);
        this.mesh.position.set(position.x, position.y, position.z);
    }

    buildMesh(geometry: any, material: THREE.Material) {

        this.mesh = new THREE.Mesh(geometry, material);
    }

    getColor(color: string): string {
        if (color && color[0] == "#")
            return Config.colorNames[color] || color
        else {
            return color;
        }
    }

    // getText(text: string): THREE.Mesh {
    //     let size = 0.4;

    //     let geom = new TextGeometry(text, {
    //         font: new Font(FontJson),
    //         size,
    //         depth: 0.05,
    //         curveSegments: 3,
    //     });
    //     geom.computeBoundingBox();
    //     if (geom.boundingBox) {
    //         geom.translate(geom.boundingBox.max.x * -0.5, 0.5, 0)
    //     }

    //     var mat = new THREE.MeshBasicMaterial({ color: "#000000" });

    //     let textMesh = new THREE.Mesh(geom, mat);
    //     if (this.viewer && !this.viewer.model.getData().is2d) {
    //         textMesh.rotateY(90 * Math.PI / 180);
    //         textMesh.rotateZ(90 * Math.PI / 180);
    //     } else {
    //         // textMesh.rotateZ(-1 * this.model.origin.zAngle * Math.PI / 180);
    //     }
    //     textMesh.updateMatrix();

    //     return textMesh
    // }

    updateFromTrack(_track: { lat?: number, lon?: number, x?: number, y?: number, z?: number }): void {
        try {

            let track = { ..._track };
            let { x, y, z } = Tools.applyTransform2(track as GPS, this.model.origin, this.model.offset);
            track.x = x;
            track.y = y;
            track.z = z;

            if (typeof this.mesh === "undefined") {
                return;
            }

            this.mesh.position.set(track.x, track.y, track.z);

            this.mesh.updateMatrix();

        } catch (e) {
            console.error(e)
        }
    }

    buildTrace(path: Track[]): void {
        const THREE: any = (window as any).THREE;
        let type = 'tube'; // line | tube
        this.tracePath = null;
        const points: any[] = [];

        path.forEach((pos: Track) => {
            // pos.z = pos.z + this.model.offset.z;
            let { x, y, z } = Tools.applyTransform2(pos, this.model.origin, this.model.offset);
            // Pousser les coordonnées à plat dans le tableau
            if (type == "tube") {
                points.push(new THREE.Vector3(x, y, z))
            } else {
                points.push(x, y, z);
            }
        });
        if (type == "tube") {
            if (points.length < 2) return;

            const curve = new THREE.SplineCurve3(points);

            const geometry = new THREE.TubeGeometry(
                curve,
                points.length,  // segments
                0.1 * (this.model.origin.scale ?? 1),               // rayon
                4,                  // segments radiaux
                false               // fermé
            );

            const material = new THREE.MeshBasicMaterial({
                color: 0x000000,
                // depthTest: false,
                // depthWrite: false,
                side: THREE.DoubleSide,
            });

            this.tracePath = new THREE.Mesh(geometry, material);
        } else {
            const float32Array = new Float32Array(points);
            const geometry = new THREE.BufferGeometry();
            geometry.addAttribute('position', new THREE.BufferAttribute(float32Array, 3));

            this.tracePath = new THREE.Line(geometry, this.materials.pathMaterial.clone());
        }

        this.addObject('trace', this.tracePath)
    }

    addObject(overlayName: string, mesh: any): void {

        if (!this.viewer.impl.overlayScenes[overlayName]) {
            this.viewer.impl.createOverlayScene(overlayName);
        }

        this.viewer.impl.addOverlay(overlayName, mesh);
        this.viewer.impl.invalidate(true);
    }

    removeObject(overlayName: string, mesh: any): void {
        this.viewer.impl.removeOverlay(overlayName, mesh);
        this.viewer.impl.invalidate(true);
    }
}